<template>

  
        <DBox
            :id="'cmp-catalog-artist-sidewindow-related_artist'"
            :addButton="false"
            :addLink="false"
            :addLinkLabel="$t('add_new_credits')"
            @add_click="onAddCredit"
        >
            <NTable
                class="dbox1"
                id="catalog-artist-sidewindow-related_artist"
                
                :config="tableConfig"
                :headers="Headers"
                :items="list"            
            >
            <template v-slot:item="{ item, tdcon }">
                <tr
                   
                >
                    <td v-bind="tdcon('start_date')">
                        <span>{{item['start_date']}}</span>
                    </td>
          
                    <td v-bind="tdcon('date_name')">
                         <span>{{item['date_name']}}</span>
                   
                    </td>
                     <td v-bind="tdcon('venue')">
                         <span>{{item['booking_location_name']}}</span>
                   
                    </td>
                    <td v-bind="tdcon('city')">
                         <span>{{item['city']}}</span>
                   
                    </td>
                
                  
                    
                </tr>
            </template>
            </NTable>
      
        </DBox>
  
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from '../../../../plugins/datatable';
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {

    selectedArtistDetails: {
        type: Object,
    },
  },
  components: {
        NTable,
        DBox
   
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
     
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 28,
        fullHeight:true
      }),
  
    };
  },
  computed:{
        Headers: function () {
            return [
                createTableHeader("start_date", {  f:0.2}),
                createTableHeader("date_name", { f:0.4 }),
                createTableHeader("venue",{  f:0.3}),
                 createTableHeader("city",{ f:0.1})
             
                
              
            ];
        },

        list:function(){
            return this.selectedArtistDetails.related_bookings||[]
        },
     

  

  },
  methods:{
      onAddCredit:function(params) {
          
      }

  }

}
</script>
<style lang="scss">
.cmp-catalog-artist-sidewindow-related_artist{
  
  .dt-ntable {
    //--ntable-height: 170px;
  }

}
</style>
